import React from 'react';
import ManualCheckout from './ManualCheckout';
import CheckoutAuthorizeNet from './CheckoutAuthorizeNet';

/**
 * Chooses the checkout implementation.
 *
 * Authorize.Net card checkout is being rolled out staging-first. The backend
 * only registers the SANDBOX payment routes today, so enabling card checkout in
 * a production build would post to an endpoint that does not exist.
 *
 * Controlled by REACT_APP_CHECKOUT_PROVIDER:
 *   "authorizenet" -> card checkout   (set in .env.staging)
 *   anything else  -> Zelle/Venmo     (current production behaviour)
 *
 * Flipping production is deliberately a two-part change: set this variable in
 * .env.production AND uncomment the production routes in the functions repo.
 */
const CheckoutRouter = () => {
  const provider = process.env.REACT_APP_CHECKOUT_PROVIDER;

  if (provider === 'authorizenet') {
    return <CheckoutAuthorizeNet />;
  }

  return <ManualCheckout />;
};

export default CheckoutRouter;
